import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'
import ReactPlayer from 'react-player'
import Dropzone from 'react-dropzone'
import { withTheme } from '@material-ui/core/styles'

// import other components within the same project here
import Config from "composer/Config.jsx";

import PannellumVideoPlayer from "composer/views/stage/MoviePlayer/PannellumVideoPlayer.jsx"

import {
  Button,
  Icon,
} from '@material-ui/core';

import { grey } from '@material-ui/core/colors';

class StageMediaMovie extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
    };
    autoBind(this);
  }

  reactPlayerOnProgress(data) {
    let playedSeconds = parseFloat(data.playedSeconds);
    this.props.parent.state.playbackTime = playedSeconds;

    if (!this.props.parent.refs.moviePlayerHolder.state.isSeeking) {
      this.props.parent.refs.moviePlayerHolder.forceUpdate();
      this.props.parent.props.parent.refs.stageElementListView.forceUpdate();
    }
  }

  uploadClicked() {
    this.props.root.refs.stageViewerPage.uploadFile();
  }

  render() {
    let fileUrl = "";
    if (this.props.stageData) {
      if (this.props.stageData['movie_list'].length > 0) {
        let movieData = this.props.stageData['movie_list'][0];
        fileUrl = Config.BASE_PATH() + movieData['path'];
      }
    }

    let is360View = false;
    let isPlaying = false;
    if (this.props.parent.refs.moviePlayerHolder) {
      is360View = this.props.parent.refs.moviePlayerHolder.state.is360View;
      isPlaying = this.props.parent.refs.moviePlayerHolder.state.isPlaying;
    }

    if (!is360View && this.refs.pannellumVideoPlayer) {
      this.refs.pannellumVideoPlayer.refs.pannellumVideo.getViewer().destroy();
    }

    let mediaHeight = this.props.maxHeight - (this.props.parent.props.parent.state.moviePlayerHolderHeight + this.props.parent.props.parent.state.stageElementListViewHeight);

    return (
      <div style={{height:mediaHeight, backgroundColor:'Black'}} ref="div">
        <If condition={fileUrl == ""}>
          <Then>
            <div style={{width:'100%', height:'100%', backgroundColor:grey[300]}}>
              <Dropzone onDrop={acceptedFiles => this.props.parent.props.parent.props.parent.onFileDrop(acceptedFiles)}>
                {({getRootProps, getInputProps}) => (
                    <div style={{width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center', textAlign:'center'}} {...getRootProps()}>
                      <input {...getInputProps()} />
                      <div>
                        <div style={{color:this.props.theme.palette.primary.main, fontWeight:'bold'}}>
                          Drag and drop file here, or click to select file
                        </div>
                        <br/>
                        Supported file type: {Config.GET_ALLOWED_FILE_EXTENSION("video").replace(/,/g, " / ")}
                      </div>
                    </div>
                )}
              </Dropzone>
            </div>
          </Then>
          <Else>
            {/* <If condition={is360View}> */}
            <If condition={is360View}>
              <Then>
                <PannellumVideoPlayer parent={this} root={this.props.root} ref="pannellumVideoPlayer"
                  url={fileUrl}
                />
              </Then>
              <Else>
                <ReactPlayer
                  ref="reactPlayer"
                  width="100%"
                  height="100%"
                  url={fileUrl}
                  playing={isPlaying}
                  onProgress={this.reactPlayerOnProgress}
                />
              </Else>
            </If>
          </Else>
        </If>
      </div>
    )
  }
}

export default withTheme(StageMediaMovie);
